// code-reaper-ignore - file is referenced as "browser" entry in package.json
export const getCurrentRouteSamplingRate = () => 100;
export const isAutomaticExposureCollectionEnabled = () => true;
